import { useIntl } from 'react-intl';
import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from 'recharts';

import { formatYAxisLabel } from '../lib';
import { ChartTooltip } from './chart-tooltip';

import styles from './charts.module.css';

export function OverviewChart({ data, currency }) {
	const intl = useIntl();

	return (
		<div className={styles.card}>
			<h3 className={styles.cardTitle}>
				{intl.formatMessage({ id: 'FinPathDashboardID11' })}
			</h3>
			<div
				className={styles.chartWrapper}
				tabIndex={-1}
				onFocus={e => e.target.blur()}
			>
				<ResponsiveContainer width='100%' height='100%'>
					<BarChart
						data={data}
						margin={{ top: 20, right: 30, left: 50, bottom: 5 }}
					>
						<CartesianGrid strokeDasharray='3 3' vertical={false} />
						<XAxis dataKey='month' />
						<YAxis width={50} tickFormatter={formatYAxisLabel} />
						<Tooltip
							content={<ChartTooltip currency={currency} />}
							animationDuration={0}
						/>
						<Legend />
						<Bar
							dataKey='Expenses'
							name={intl.formatMessage({ id: 'ExpenseId01' })}
							fill='#ffb4b4'
							radius={[5, 5, 0, 0]}
							barSize={20}
						/>
						<Bar
							dataKey='Income'
							name={intl.formatMessage({ id: 'IncomeId01' })}
							fill='#349f71'
							radius={[5, 5, 0, 0]}
							barSize={20}
						/>
					</BarChart>
				</ResponsiveContainer>
			</div>
		</div>
	);
}
